import { apiFetch } from 'zn-common'
import { MenuProps } from './interface'

export const checkIsLogin = (p = {}) => (
  (apiFetch({ url: 'agent/user/checkLogin.do', prefix: '/open/znClientapi', }, {
    data: p,
    showErrMsg: false,
  }).then((res: any) => {
    // @ts-ignore
    console.log('res && res._failure', res && res._failure)
    if (res && res.isVaild !== 1) {
      localStorage.removeItem('loginAreaCodeIndex')
      localStorage.removeItem('loginUserNum')
    }
    return res
  })) as Promise<MenuProps[]>
)

// export const simulateCheckUrl = (url: string): void => {
//   if (process.env.ZN_EVN_DEV_ISOLATED !== 'true' || !url) return
//   apiFetchWithErr({
//     url: `auth/checkurl.do?url=${url}`,
//     method: 'post'
//   }, {}).then()
// }
